@if (formGroup && client) {
  <div [formGroup]="formGroup">
    <nz-select
      nzShowSearch
      nzAllowClear
      nzPlaceHolder="Select a location"
      [formControlName]="formGroupOrControlName"
      (nzOnSearch)="search($event)"
      >
      @for (option of options; track option) {
        <nz-option
          [nzValue]="option.value"
          [nzLabel]="option.label"
        ></nz-option>
      }
    </nz-select>
  </div>
}
